import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from 'components';

const HomePage = lazy(() => import('pages/HomePage/index'));
const OffersPage = lazy(() => import('pages/OffersPage'));
const WebViewPage = lazy(() => import('pages/WebViewPage'));
const Checkout = lazy(() => import('components/Checkout/Checkout'));
const Invoice = lazy(() => import('components/Invoice/Invoice'));
const Login = lazy(() => import('pages/Login/Login'));
const NotFoundPage = lazy(() => import('pages/NotFoundPage'));

const FAQ_URL = 'https://bbumgames.freshdesk.com/en/support/home';

export const AppRoutes = ({ pwaProps }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<MainLayout {...pwaProps} />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/store" element={<OffersPage />} />
        <Route path="/faq" element={<WebViewPage staticUrl={FAQ_URL} />} />
        <Route path="/webview" element={<WebViewPage />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/invoice_status/:iId" element={<Invoice />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
